import React from 'react';

export const PipedriveSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="#017737"
			/>
			<path
				d="M13.7389 13.5678C13.7389 15.4746 14.7062 17.5315 16.8349 17.5315C18.4135 17.5315 20.0096 16.2991 20.0096 13.5398C20.0096 11.1206 18.7549 9.49657 16.8874 9.49657C15.3657 9.49657 13.7389 10.5655 13.7389 13.5678ZM17.6373 5.96423C21.454 5.96423 24.0203 8.98711 24.0203 13.4868C24.0203 17.9158 21.3169 21.0079 17.452 21.0079C15.6093 21.0079 14.429 20.2187 13.8119 19.6474C13.8163 19.7829 13.8192 19.9345 13.8192 20.0965V26.1025H9.86537V10.1003C9.86537 9.86761 9.79096 9.79399 9.56045 9.79399H8.20068V6.28964H11.5184C13.0459 6.28964 13.4369 7.06707 13.5113 7.66635C14.1314 6.97137 15.4168 5.96423 17.6373 5.96423Z"
				fill="white"
			/>
		</svg>
	);
};
